import { Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output } from '@angular/core'
import { IdentityService } from '../../../services/identity.service'
import { LocaleService } from '../../../../../framework/locale/services/locale.service'
import { UserProfileService } from '../../../../../framework/authentication/services/user-profile.service'
import { onfidoPhrasesNlNL } from './onfido-phrases-nl-NL'

let _uniqueIdCounter: number = 0

const languageOnfidoLocaleMap = {
    nl: 'en_US',
    dk: 'en_US',
    en: 'en_US',
    de: 'de_DE',
    fr: 'fr_FR',
}

@Component({
    selector: 'mg-deal-onfido',
    templateUrl: './deal-onfido.component.html',
    styleUrls: ['./deal-onfido.component.scss'],
})
export class DealOnfidoComponent implements OnInit, OnDestroy {
    @HostBinding('class.isLoading')
    isLoading: boolean = true

    Onfido: any
    onfidoSdkUiInstance: any
    onfidoElementId: string = `configurator-color-component-${_uniqueIdCounter++}`

    @Output()
    // eslint-disable-next-line @angular-eslint/no-output-native
    complete: EventEmitter<boolean> = new EventEmitter()

    constructor(
        private identityService: IdentityService,
        private localeService: LocaleService,
        private userProfileService: UserProfileService
    ) {}

    ngOnInit() {
        ;(window['global'] as any) = window['global'] || window
        this.Onfido = require('onfido-sdk-ui')
        this.initApiClient()
    }

    async initApiClient() {
        const token = await this.identityService.getOnfidoToken()

        const onfidoInitOptions = {
            token,
            containerId: this.onfidoElementId,
            useModal: false,
            isModalOpen: true,
            onComplete: this.onOnfidoComplete.bind(this),
            language:
                this.localeService.language === 'nl'
                    ? { locale: 'en_US', phrases: onfidoPhrasesNlNL }
                    : languageOnfidoLocaleMap[this.localeService.language] || 'en_US',
            useMemoryHistory: true,
            smsNumberCountryCode: this.localeService.country,
            steps: [
                {
                    type: 'document',
                    options: {
                        documentTypes: {
                            passport: false,
                            driving_licence: true,
                            national_identity_card: false,
                        },
                    },
                },
                {
                    type: 'face',
                    options: {
                        useMultipleSelfieCapture: true,
                    },
                },
            ],
        }

        console.log({ onfidoInitOptions })

        // detect dutch mobile phone number
        if (this.localeService.country === 'NL') {
            let telephoneNumber = this.userProfileService.userProfile.getValue().telephoneNumber.trim()

            if (telephoneNumber.startsWith('06')) {
                telephoneNumber = `+31${telephoneNumber.substring(1)}`
            }

            if (telephoneNumber.startsWith('+316') || telephoneNumber.startsWith('00316')) {
                onfidoInitOptions['userDetails'] = {
                    smsNumber: telephoneNumber,
                }
            }
        }

        this.onfidoSdkUiInstance = this.Onfido.init(onfidoInitOptions)

        setTimeout(() => {
            this.isLoading = false
        }, 50)
    }

    ngOnDestroy() {
        if (this.onfidoSdkUiInstance && this.onfidoSdkUiInstance.tearDown) {
            this.onfidoSdkUiInstance.tearDown()
        }
    }

    async onOnfidoComplete() {
        this.isLoading = true
        this.onfidoSdkUiInstance.tearDown()
        await this.identityService.executeLicenseCheck()
        this.isLoading = false
        this.complete.emit(true)
    }
}
